import Vue from "vue";
import VueCookies from "vue-cookies";
import axios from "axios";

Vue.use(VueCookies);

const axiosInstance = axios.create({
	baseURL: process.env.VUE_APP_URL_NOTIFICATION
});

var config = {
	headers: { "Access-Control-Allow-Origin": "*" }
};

export const apiNotification = {
	get(endpoint) {
		return axiosInstance.get(endpoint, config);
	},
	post(endpoint, body) {
		return axiosInstance.post(endpoint, body, config);
	},
	put(endpoint, body) {
		return axiosInstance.put(endpoint, body, config);
	},
	delete(endpoint) {
		return axiosInstance.delete(endpoint, config);
	},
	valid() {
		
	}
};
